import { render, staticRenderFns } from "./UploadComp.vue?vue&type=template&id=0db9f2f4&scoped=true&"
import script from "./UploadComp.vue?vue&type=script&lang=js&"
export * from "./UploadComp.vue?vue&type=script&lang=js&"
import style0 from "./UploadComp.vue?vue&type=style&index=0&id=0db9f2f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db9f2f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VIcon,VProgressLinear,VSnackbar})
